module.exports = __webpack_public_path__ + "img/blanco-viciado.51c30d56.png";